@if (showProfileSplash) {
  <app-profile-splash (dismissed)="onSplashDismissed()"></app-profile-splash>
}
<app-wizard-progress-banner></app-wizard-progress-banner>
<router-outlet></router-outlet>
<!-- <mat-divider></mat-divider> -->
@if (showNavBar) {
  <nav mat-tab-nav-bar class="fixed-bottom">
    @for (link of links; track link) {
      <a
        mat-tab-link
        (click)="link.clickHandler()"
        [ngClass]="link.active ? 'active' : ''"
        [attr.data-test]="link.title"
        [attr.data-testid]="link.title"
        >
        <label>
          @if (link.svgIcon) {
            <mat-icon [svgIcon]="link.icon" data-test="icon"></mat-icon>
          } @else {
            <mat-icon data-test="icon">{{ link.icon }}</mat-icon>
          }
          <span>{{ link.title }}</span>
        </label>
      </a>
    }
  </nav>
}
